export const ActiveSports = [
  'running',
  'tennis',
  'bike',
  'paddle',
  'hiking',
  'badminton',
  'climbing',
  'trail',
  'swim',
  'football',
  'golf',
  'trampoline',
  'table-tennis',
  'basketball',
  'core-training',
  'ski',
  'combat',
  'marche',
  'pickleball',
];
